module.exports = __webpack_public_path__ + "static/media/p22.778c65f6.jpeg";